import React from "react";
import { useThemedLoading } from "components/hooks/useThemedLoading";

interface LoadingStateProps {
  size?: "small" | "large";
  label?: string;
  isLoading?: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  size = "large",
  label = "Loading...",
  isLoading = true,
}) => {
  const loadingGif = useThemedLoading();
  if (!isLoading) return null;

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className={`${size === "small" ? "w-4 h-4" : "w-16 h-16"} shrink-0`}>
        <img src={loadingGif} className="w-full h-full object-contain" />
      </div>
      <p className="text-fg-bold text-center">{label}</p>
    </div>
  );
};
